import { Component, input } from '@angular/core';

@Component({
  selector: 'portal-erfolg-2-svg',
  standalone: true,
  templateUrl: './erfolg-2.component.svg',
  styleUrl: './erfolg-2.component.scss',
})
export class Erfolg2SvgComponent {
  public showCheckMark = input<boolean>(false);
}
